import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-10 px-4 sm:px-6 lg:px-24" }
const _hoisted_2 = { class: "sm:flex sm:items-center" }
const _hoisted_3 = { class: "flex sm:flex-auto" }
const _hoisted_4 = { class: "flex flex-col" }
const _hoisted_5 = { class: "text-base font-semibold leading-6 text-gray-900" }
const _hoisted_6 = { class: "flex flex-col gap-4 ml-auto" }
const _hoisted_7 = { class: "mt-8 flow-root" }
const _hoisted_8 = { class: "-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8" }
const _hoisted_9 = { class: "flex flex-col min-w-full py-2 align-middle sm:px-6 lg:px-8" }
const _hoisted_10 = { class: "overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg" }
const _hoisted_11 = { class: "flex items-center justify-start" }
const _hoisted_12 = { class: "flex items-center gap-3" }
const _hoisted_13 = { class: "font-normal text-sm text-gray-700" }
const _hoisted_14 = { class: "flex gap-2 ml-auto" }
const _hoisted_15 = { class: "p-input-icon-left" }
const _hoisted_16 = { class: "rounded rounded-bg bg-theme-button1-bg text-theme-button1-txt text-center w-[100px] py-2 uppercase text-xs" }
const _hoisted_17 = ["onClick"]

import { ref, onMounted, watch } from 'vue'
import { Car, CarLocation, NotificationType } from '@/types/index'
import Admin from '@/composables/admin/index'
import { handleApiError } from '@/utils/common'
import SaveCarLocation from '@/components/admin/SaveCarLocation.vue'
import Notification from '@/widgets/Notification.vue'
import SlideOver from '@/widgets/SlideOver.vue'
import { FilterMatchMode } from 'primevue/api'
import { Switch } from '@headlessui/vue'
import ConfirmationModal from '@/widgets/ConfirmationModal.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'locations',
  props: ['id'],
  setup(__props) {

const props = __props
const locations = ref<CarLocation[] | null>(null)
const { carLocations, removeCarLocation } = Admin()
const isLoading = ref<boolean>(false)
const car = ref<Car | null>(null)
const openLocationDialog = ref<boolean>(false)
const notif = ref<NotificationType>({ show: false, type: 'success', message: '', messageDetails: ''})
const locationType = ref<'chauffer' | 'transfer'>('chauffer')
const filters = ref()
const loading = ref<boolean>(false)
const dt = ref()
const enabled = ref<boolean>(true)
const openConfirmModal = ref<boolean>(false)
const deleteItem = ref<number>(0)

onMounted(async () => {

   await fetchCarLocations()  
})

const handleConfirmClose = () => openConfirmModal.value = false

const fetchCarLocations = async () => {
   isLoading.value = true
   const response = await carLocations(props.id, locationType.value)
   isLoading.value = false
   if (response.status == 200) {
      
      locations.value = response.data.locations
      car.value = response.data.car
   } else {
      const error = handleApiError(response)
      console.log(error)
   }
}

const handleAddCarLocation = async () => {
   openLocationDialog.value = true
}

const notifClosed = () : void => {
   notif.value.show = false
}

const handleSaveCarLocationSuccess = async () => {
   openLocationDialog.value = false
   notif.value = { show: true, type: 'success', message: 'Success', messageDetails: 'The location has been attached to the car successfully'}
   setTimeout(() => { notifClosed() }, 4000)
   
   await fetchCarLocations()
}

const handleSaveCarLocationError = async (error: string) => {
   openLocationDialog.value = false
   notif.value = { show: true, type: 'error', message: 'Error', messageDetails: error}
   setTimeout(() => { notifClosed() }, 4000)
}

const handleDelete = (id: number) => {

   deleteItem.value = id
   openConfirmModal.value = true
}

const askingConfirmed = async () => {
if (!isLoading.value && deleteItem.value) {
   isLoading.value = true
   const response = await removeCarLocation(deleteItem.value, locationType.value)

   if (response.status == 204) {
      await fetchCarLocations()
   } else {
      const error = handleApiError(response)
      notif.value = { show: true, type: 'error', message: 'Error', messageDetails: error}
      setTimeout(() => { notifClosed() }, 4000)
   }

   isLoading.value = false
   openConfirmModal.value = false
}  
}

const initFilters = () => {
   filters.value = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS }
   }
}

initFilters()

const clearFilter = () => {
   initFilters()
}

const exportCSV = (event: any) => {
   dt.value.exportCSV()
}

watch(enabled, (newValue, oldValue) => {

   locationType.value = newValue ? 'chauffer' : 'transfer'
   fetchCarLocations().then(() => {})
})


return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h1", _hoisted_5, _toDisplayString(car.value ? car.value.name : ''), 1),
            _cache[8] || (_cache[8] = _createElementVNode("p", { class: "mt-2 text-sm text-gray-700" }, "View all the locations added for this car", -1))
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (handleAddCarLocation())),
              type: "button",
              class: "block rounded-md bg-theme-active px-3 py-2 text-center text-sm font-semibold text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            }, " Add Location ")
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_DataTable, {
                exportFilename: "bookings",
                ref_key: "dt",
                ref: dt,
                class: "text-sm",
                filters: filters.value,
                "onUpdate:filters": _cache[5] || (_cache[5] = ($event: any) => ((filters).value = $event)),
                value: locations.value,
                paginator: "",
                showGridlines: "",
                rows: 10,
                dataKey: "id",
                filterDisplay: "menu",
                loading: loading.value,
                globalFilterFields: ['locality.name']
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, "Currently showing " + _toDisplayString(locationType.value) + " locations", 1),
                      _createVNode(_unref(Switch), {
                        modelValue: enabled.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((enabled).value = $event)),
                        class: "group relative inline-flex h-5 w-10 flex-shrink-0 cursor-pointer items-center justify-center rounded-full outline-none"
                      }, {
                        default: _withCtx(() => [
                          _cache[9] || (_cache[9] = _createElementVNode("span", { class: "sr-only" }, "Use setting", -1)),
                          _cache[10] || (_cache[10] = _createElementVNode("span", {
                            "aria-hidden": "true",
                            class: "pointer-events-none absolute h-full w-full rounded-md bg-white"
                          }, null, -1)),
                          _createElementVNode("span", {
                            "aria-hidden": "true",
                            class: _normalizeClass([enabled.value ? 'bg-indigo-600' : 'bg-gray-200', 'pointer-events-none absolute mx-auto h-4 w-9 rounded-full transition-colors duration-200 ease-in-out'])
                          }, null, 2),
                          _createElementVNode("span", {
                            "aria-hidden": "true",
                            class: _normalizeClass([enabled.value ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none absolute left-0 inline-block h-5 w-5 transform rounded-full border border-gray-200 bg-white shadow ring-0 transition-transform duration-200 ease-in-out'])
                          }, null, 2)
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("span", _hoisted_15, [
                        _createVNode(_component_InputText, {
                          modelValue: filters.value['global'].value,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.value['global'].value) = $event)),
                          placeholder: "Keyword Search"
                        }, null, 8, ["modelValue"])
                      ]),
                      _createVNode(_component_Button, {
                        type: "button",
                        icon: "pi pi-filter-slash",
                        label: "Clear",
                        outlined: "",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (clearFilter()))
                      }),
                      _createVNode(_component_Button, {
                        icon: "pi pi-external-link",
                        label: "Export",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (exportCSV($event)))
                      })
                    ])
                  ])
                ]),
                empty: _withCtx(() => _cache[11] || (_cache[11] = [
                  _createTextVNode(" No locations added yet ")
                ])),
                loading: _withCtx(() => _cache[12] || (_cache[12] = [
                  _createTextVNode(" Loading bookings data. Please wait. ")
                ])),
                default: _withCtx(() => [
                  _createVNode(_component_Column, {
                    field: "locality.name",
                    header: "Name"
                  }, {
                    body: _withCtx(({ data }) => [
                      _createTextVNode(_toDisplayString(data.locality?.name), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "locality.type",
                    header: "Type",
                    exportHeader: "Type",
                    class: "w-[14rem]"
                  }, {
                    body: _withCtx(({ data }) => [
                      _createElementVNode("div", _hoisted_16, _toDisplayString(data.locality?.type), 1)
                    ]),
                    _: 1
                  }),
                  (locationType.value == 'chauffer')
                    ? (_openBlock(), _createBlock(_component_Column, {
                        key: 0,
                        field: "rate_per_hour",
                        header: "Rate"
                      }, {
                        body: _withCtx(({ data }) => [
                          _createTextVNode(_toDisplayString(data.rate_per_hour), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (locationType.value == 'transfer')
                    ? (_openBlock(), _createBlock(_component_Column, {
                        key: 1,
                        field: "rate",
                        header: "Rate"
                      }, {
                        body: _withCtx(({ data }) => [
                          _createTextVNode(_toDisplayString(data.rate), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_Column, {
                    header: "Actions",
                    exportable: false,
                    class: "w-[14rem]"
                  }, {
                    body: _withCtx(({ data }) => [
                      _createElementVNode("button", {
                        onClick: ($event: any) => (handleDelete(data.id)),
                        type: "button",
                        class: "rounded rounded-bg bg-theme-button5-bg text-theme-button5-txt text-center w-[100px] py-2 uppercase text-xs"
                      }, " Delete ", 8, _hoisted_17)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["filters", "value", "loading"])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(SlideOver, {
      show: openLocationDialog.value,
      onClosed: _cache[6] || (_cache[6] = ($event: any) => (openLocationDialog.value = false))
    }, {
      content: _withCtx(() => [
        _createVNode(SaveCarLocation, {
          carId: __props.id,
          locationType: locationType.value,
          onSuccess: handleSaveCarLocationSuccess,
          onError: handleSaveCarLocationError
        }, null, 8, ["carId", "locationType"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(Notification, {
      show: notif.value.show,
      type: notif.value.type,
      message: notif.value.message,
      messageDetails: notif.value.messageDetails,
      onClosed: notifClosed
    }, null, 8, ["show", "type", "message", "messageDetails"]),
    _createVNode(ConfirmationModal, {
      show: openConfirmModal.value,
      onClosed: handleConfirmClose
    }, {
      buttons: _withCtx(() => [
        _createElementVNode("button", {
          onClick: askingConfirmed,
          type: "button",
          class: _normalizeClass([isLoading.value ? 'opacity-60 cursor-not-allowed' : 'hover:bg-red-500 cursor-pointer', "inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm text-white shadow-sm xs:ml-3 xs:w-auto"])
        }, "Yes, delete", 2),
        _createElementVNode("button", {
          onClick: _cache[7] || (_cache[7] = ($event: any) => (openConfirmModal.value = false)),
          type: "button",
          class: "mt-3 inline-flex w-full cursor-pointer justify-center rounded-md bg-white px-3 py-2 text-sm text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 xs:mt-0 xs:w-auto"
        }, "Cancel")
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})